import download_component from '#BASE/components/downLoad/DownLoadCenter';

export default {
    mixins: [download_component],
    props: {
        currentTabProp: String,
    },
    data() {
        return {
            currentTab: '',
            IsSettingComplete: false,
        };
    },
    methods: {
        switchTab(name) {
            this.currentTab = name;
        },
        async GetLoginEntryConfig() {
            let _this = this;
            let result = await $.post('/api/LoginEntry/GetLoginEntrySetting');
            if (result) {
                var pcUrl = '';
                var androidUrl = '';
                if (result.LoginEntryPCUrl) {
                    pcUrl = result.LoginEntryPCUrl;
                }
                else if (result.LoginEntryPCFile) {
                    pcUrl = _this.FileName(result.LoginEntryPCFile);
                }
                if (result.LoginEntryAndroidUrl) {
                    androidUrl = result.LoginEntryAndroidUrl;
                }
                else if (result.LoginEntryAndroidFile) {
                    androidUrl = _this.FileName(result.LoginEntryAndroidFile);
                }
                if (pcUrl != '' || androidUrl != '') {
                    _this.IsSettingComplete = true;
                }
            }
        },
    },
    async mounted() {
        this.currentTab = this.currentTabProp;
        await this.GetLoginEntryConfig();
    },
};
